import { createComponent } from '../lib';
import { VmDefaultSettings, VmIcon, VmMenu, VmMenuItem, VmMenuRadio, VmMenuRadioGroup, VmSettings, VmSubmenu } from '@vime/core';
import { define } from '../lib';
define('vm-default-settings', VmDefaultSettings);
define('vm-icon', VmIcon);
define('vm-menu', VmMenu);
define('vm-menu-item', VmMenuItem);
define('vm-menu-radio', VmMenuRadio);
define('vm-menu-radio-group', VmMenuRadioGroup);
define('vm-settings', VmSettings);
define('vm-submenu', VmSubmenu);
;
export default createComponent('vm-default-settings', new Set(['pin', 'i18n', 'playbackReady', 'playbackRate', 'playbackRates', 'isVideoView', 'playbackQuality', 'playbackQualities', 'textTracks', 'currentTextTrack', 'audioTracks', 'currentAudioTrack', 'isTextTrackVisible']));
